export const PACKAGES = {
  ALL_ONE: "ALL1",
  ALL_TWO: "ALL2",
  ALL_MONTH: "ALLMO",
  ALL_YEAR: "ALLYR",

  MLB_ONE: "MLB1",
  MLB_MONTH: "MLBMO",
  MLB_FULL: "MLBFULL",

  NFL_ONE: "NFL1",
  NFL_MONTH: "NFLMO",
  NFL_FULL: "NFLFULL",

  NCAAF_ONE: "NCAAF1",
  NCAAF_MONTH: "NCAAFMO",
  NCAAF_FULL: "NCAAFFULL",

  NHL_ONE: "NHL1",
  NHL_MONTH: "NHLMO",
  NHL_FULL: "NHLFULL",

  NBA_ONE: "NBA1",
  NBA_MONTH: "NBAMO",
  NBA_FULL: "NBAFULL",

  NCAAB_ONE: "NCAAB1",
  NCAAB_MONTH: "NCAABMO",
  NCAAB_FULL: "NCAABFULL",

  MMA_ONE: "MMA1",
  MMA_MONTH: "MMAMO",
  MMA_FULL: "MMAFULL",

  TENNIS_ONE: "TENNIS1",
  TENNIS_MONTH: "TENNISMO",
  TENNIS_FULL: "TENNISFULL",
};

// Minimum length enforced when an admin sets a user's password.
export const MIN_PASSWORD_LENGTH = 8;



// WEBPACK FOOTER //
// ./src/constants.js